import { connect } from 'react-redux';
import Breadcrumbs from '../../../shared/components/breadcrumbs';
import {
  addBreadcrumbT,
  deleteBreadcrumbsT,
  deleteBreadcrumbTitleT,
  setBreadcrumbTitleT
} from "../../../../state/actions/shared/breadcrumbs";

const BreadcrumbsRedux = (props) => (
  <Breadcrumbs
    entityType="article"
    searchEntities={['landing_page', 'guide']}
    {...props}
  />
);

const mapStateToProps = (state, ownProps) => {
  const { entityId } = ownProps;
  const pageEntities = state.articles.article;
  const {editor} = pageEntities;
  const currentPage = editor[entityId]
  const { breadcrumb, breadcrumbTitle, title, updateId } = currentPage;
  return {
    breadcrumb,
    breadcrumbTitle,
    entityId,
    entityTitle: title,
    entityUpdateId: updateId,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {entityId:id} = ownProps;
  return {
    onDeleteBreadcrumb: () => dispatch(deleteBreadcrumbsT('article', id)),
    onDeleteBreadcrumbTitle: () => dispatch(deleteBreadcrumbTitleT('article', id)),
    onSelectBreadcrumb: (breadcrumb) => dispatch(addBreadcrumbT('article', breadcrumb, id)),
    onSetBreadcrumbTitle: (breadcrumbTitle) => dispatch(setBreadcrumbTitleT('article', breadcrumbTitle, id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsRedux);
